/* eslint-disable react/forbid-prop-types */
import React from "react"
import { graphql } from "gatsby"
import propTypes from "prop-types"
import styled from "styled-components"

import SEO from "../components/Seo"
import withTranslation from "../i18n/withTranslation"
import TeamItem from "../components/TeamItem"

const Wrapper = styled.div`
  max-width: 100%;
  margin: 0 auto 100px;
  padding: 0 25px;

  .partnersWrapper {
    margin-top: 150px;
    clear: both;
    display: flex;
    flex-directon: row;
    justify-content: space-evenly;

    > div:nth-child(2) {
      text-align: right;
    }

    @media screen and (max-width: 768px) {
      flex-direction: column;

      > div:nth-child(2) {
        text-align: left;
        margin-top: 50px;
      }
    }
  }
`

const TeamPage = ({ data, t }) => {
  const members = data.allMarkdownRemark.edges
  return (
    <Wrapper>
      <SEO title="The Team" />
      {members.map(e => (
        <TeamItem key={e.node.id} data={e.node} />
      ))}

      <div className="partnersWrapper">
        <div>
          <h2>{t("team.press")}</h2>
          <p>Fernanda Lascurain</p>
          <a
            href="mailto:flascurain@jmbalmaceda.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            flascurain@jmbalmaceda.com
          </a>
        </div>

        <div>
          <h2>{t("team.gallery")}</h2>
          <p>Angulo Cero</p>
          <a href="www.angulo0.com" target="_blank">
            www.angulo0.com
          </a>
        </div>
      </div>
    </Wrapper>
  )
}

TeamPage.propTypes = {
  data: propTypes.object.isRequired,
  t: propTypes.func.isRequired,
}

export const query = graphql`
  query {
    allMarkdownRemark(
      filter: { frontmatter: { templateKey: { eq: "team" } } }
      sort: { order: ASC, fields: frontmatter___order }
    ) {
      edges {
        node {
          id
          frontmatter {
            name
            job
            jobES
            bodyES
            avatar
          }
          html
        }
      }
    }
  }
`

export default withTranslation(TeamPage)
